import React from 'react';

import PropTypes from 'prop-types';

import Town from 'containers/town';

import { useContextMatchParams } from 'contexts/matchParams';
import { useContextResultOrigin } from 'contexts/resultOrigin';

import { Cintillo, LoadingPlaceholder, MasterBar } from 'components';
import useGetPlace from '../../dataProvider/hooks/useGetPlace';
import useResultProvider from '../../dataProvider/hooks/useResultProvider';

import { getPlace } from '../../dataProvider';

import '../home-regional/home.scss';

import { SUBTYPES } from '../../envs';
import { getSite, isLaRazon } from '../../constants/sites';
import MainMunicipal from './mainMunicipal';
import { NAVIGATION_MODE } from '../../constants';

const site = getSite();
const elSubtype = SUBTYPES.SINGLE;

const HomeMunicipal = ({ history }) => {
  const { matchParams } = useContextMatchParams();
  const {
    chartType,
    community,
    country,
    electionNumber,
    navigableMode,
    placeId,
    province,
    showMasterBar,
    town,
    type,
    year
  } = matchParams;

  const resultOrigin = useContextResultOrigin();

  const { result: dataResult } = useResultProvider({
    active: resultOrigin.primary?.active,
    year,
    type,
    subtype: elSubtype,
    electionNumber,
    placeId: town || placeId,
    details: Boolean(town),
    parar: true,
    site
  });

  const { result: oldData } = useResultProvider({
    active: false /* buscame */,
    year: resultOrigin?.historic?.year,
    old: true,
    type,
    subtype: elSubtype,
    electionNumber,
    placeId: town || province || community || placeId,
    details: true,
    site,
    currentPartiesIds: dataResult.partiesResult || []
  });

  const selectedPlace = useGetPlace(town || placeId, type);
  const provincePlace = useGetPlace(selectedPlace?.parentId, type);

  const onChangeLocation = (e, place, fromMap) => {
    const isL = isLaRazon(site);
    if (
      (parseInt(navigableMode, 10) === NAVIGATION_MODE.INTERNAL || fromMap) &&
      !isL
    ) {
      e.preventDefault();
      switch (place.typePlace) {
        case 'PROVINCE':
          getPlace({
            filter: `sortby=main&size=1&typeplace=TOWN&parentid=${place.ineId}`,
            type,
            electionType: type
          }).then(p => {
            history.push(
              `/${country}/${navigableMode}/${year}/MUNICIPAL/${electionNumber}/${chartType}/${showMasterBar}/${p.content[0].ineId}/home-municipales-resultados.html`
            );
          });
          break;
        case 'TOWN':
          history.push(
            `/${country}/${navigableMode}/${year}/MUNICIPAL/${electionNumber}/${chartType}/${showMasterBar}/${place.grandpaId}/${place.parentId}/${place.ineId}/detalle-municipales-resultados.html`
          );
          break;
        default:
          // go to home
          break;
      }
    }
  };

  if (
    !dataResult ||
    !oldData ||
    !selectedPlace ||
    !provincePlace ||
    !resultOrigin
  ) {
    return <LoadingPlaceholder />;
  }

  return (
    <div
      className={`mainWrapper pageHome pageHome--municipal chart_${chartType}`}
    >
      <div
        className={`block ${
          dataResult.currentCountPercent === 0 ? `empty` : ''
        }`}
      >
        <MasterBar history={history} />

        <Cintillo
          currentCountPercent={dataResult.currentCountPercent}
          updateDate={dataResult.updateDate}
          withScrutiny
        />

        {town ? (
          <Town
            dataResult={dataResult}
            oldData={oldData}
            onChangeLocation={onChangeLocation}
            provincePlace={provincePlace}
            selectedPlace={selectedPlace}
          />
        ) : (
          <MainMunicipal
            dataResult={dataResult}
            oldData={oldData}
            provincePlace={provincePlace}
            onChangeLocation={onChangeLocation}
            selectedPlace={selectedPlace}
          />
        )}
      </div>
    </div>
  );
};

HomeMunicipal.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      chartType: PropTypes.string.isRequired,
      community: PropTypes.string,
      country: PropTypes.string,
      electionNumber: PropTypes.string.isRequired,
      navigableMode: PropTypes.string.isRequired,
      placeId: PropTypes.string,
      province: PropTypes.string,
      showMasterBar: PropTypes.string.isRequired,
      town: PropTypes.string,
      type: PropTypes.string.isRequired,
      year: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired
};

export default HomeMunicipal;
